import { createContext } from 'react';

const InstitutionContext = createContext({});

export default InstitutionContext;
